<template lang="html">
  <div class="animalsearch">
    <v-row class="searchinput" justify="center">
      <v-col cols="10" sm="6" md="4" lg="3">
        <v-text-field
          v-model="searchinput"
          label="Azonosító- vagy névrészlet"
          clearable
          append-icon="mdi-map-search"
          @click:append="goSearch"
        ></v-text-field>
      </v-col>
    </v-row>
    <div class="searchresult">

    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      animals: this.$store.getters.allAnimals,
      searchinput: null,
      filteredResult: [],
    }
  },
  methods:{
    filteredAnimals(){
      if (this.searchinput!==null) {
        return this.animals.filter(animal=>{
          return animal.name.toLowerCase().includes(this.searchinput.toLowerCase()) || animal.shelterID.toLowerCase().includes(this.searchinput.toLowerCase())
        })
      }else{
        return false
      }

    },
    goSearch(){
      let animals = this.filteredAnimals()
      this.$emit('searchResult', animals)
    }
  },
}
</script>

<style lang="scss" scoped>
.animalsearch{
  margin-top: 30px;
}
</style>
